/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Avatar,
    Box,
    ClickAwayListener,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Typography,
    useTheme
} from '@mui/material';

import { IconLogout, IconSettings, IconChevronDown } from '@tabler/icons';
import moment from 'moment';
import defaultAvatar from 'assets/images/avatar.png';
import useAuth from 'hooks/useAuth';

const ProfileSection = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout, user, dbUser } = useAuth();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [welcomeMessage, setWelcomeMessage] = useState('');

    const handleToggle = () => setOpen((prev) => !prev);
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };

    const handleLogout = async () => {
        await logout();
    };

    const handleNavigate = (path) => {
        navigate(path);
        setOpen(false);
    };

    useEffect(() => {
        const hour = moment().hour();
        if (hour >= 4 && hour < 12) setWelcomeMessage('☀️ Good morning');
        else if (hour >= 12 && hour < 17) setWelcomeMessage('🌤️ Good afternoon');
        else if (hour >= 17 && hour < 21) setWelcomeMessage('🌇 Good evening');
        else setWelcomeMessage('🌙 Good night');
    }, []);

    return (
        <Box>
            <Box onClick={handleToggle} ref={anchorRef} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}>
                <Avatar src={dbUser?.profileIMG ? dbUser?.profileIMG : user?.image || defaultAvatar} />
                <Typography>{dbUser?.name || dbUser?.displayName || user?.name || user?.displayName}</Typography>
                <IconChevronDown size={18} />
            </Box>

            <Popper
                className="menu-list-grow"
                open={open}
                anchorEl={anchorRef.current}
                transition
                disablePortal
                sx={{
                    zIndex: 1300,
                    left: 'unset !important',
                    top: '60px !important',
                    right: '20px !important',
                    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                placement="bottom"
                role={undefined}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                color="inherit"
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Paper
                            sx={{
                                mt: 1,
                                p: 2,
                                minWidth: 350,
                                boxShadow:
                                    'rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px'
                            }}
                            className="menu-list-grow2"
                        >
                            <Typography variant="subtitle1" gutterBottom>
                                {welcomeMessage}, {user?.name || 'User'}
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <List component="nav">
                                <ListItemButton onClick={() => handleNavigate('/settings')}>
                                    <ListItemIcon>
                                        <IconSettings stroke={1.5} size="1.2rem" />
                                    </ListItemIcon>
                                    <ListItemText primary="Account Settings" />
                                </ListItemButton>
                                <ListItemButton onClick={handleLogout}>
                                    <ListItemIcon>
                                        <IconLogout stroke={1.5} size="1.2rem" />
                                    </ListItemIcon>
                                    <ListItemText primary="Logout" />
                                </ListItemButton>
                            </List>
                        </Paper>
                    </ClickAwayListener>
                )}
            </Popper>
        </Box>
    );
};

export default ProfileSection;
